var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    id: "plex-icon-sidebar-shows-560",
    "aria-hidden": "true",
    className: "PlexIcon-plexIcon-8Tamaj",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 480c0-11.038-8.962-20-20-20H140c-11.038 0-20 8.962-20 20v20c0 11.038 8.962 20 20 20h280c11.038 0 20-8.962 20-20v-20zM540 40H20C8.962 40 0 48.962 0 60v360c0 11.038 8.962 20 20 20h520c11.038 0 20-8.962 20-20V60c0-11.038-8.962-20-20-20zm-40 70v220c0 5.52-4.48 10-10 10H70c-5.52 0-10-4.48-10-10V110c0-5.52 4.48-10 10-10h420c5.52 0 10 4.48 10 10z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.ad52ffb7.svg";
export { ForwardRef as ReactComponent };